import pageHeader from "../components/pageHeader/locals/en.json";
import productsSection from "../components/productsSection/locals/en.json";

export default {
  pageHeader,
  productsSection,
};
